import { isEmpty } from 'lodash'

export const isEmptyEntity = isEmpty
